export default __webpack_public_path__ + "static/media/video-preview-one.8ada2634.jpg";